import { RequestService } from "../../../../common/services/RequestService";
import { dataUpdateCompany } from "./adjustLicenseeInfoData";
import { API_PROFILE } from "../../../Authorization/api/constants";

export const updateCompanyRequest = async (userId, profileId, companyId, data) => {
    const response = await RequestService.put(API_PROFILE + '/' + profileId + '/update_and_fill', dataUpdateCompany({
        userId,
        companyId,
        profileId,
        ...data
    }));

    return response.data
};
